module.exports = __webpack_public_path__ + "images/full time work.png";